export const EMPLOYEES = [
    {
        value: "micro",
        label: "1-10",
    },
    {
        value: "small",
        label: "11-50",
    },
    {
        value: "mid",
        label: "51-200",
    },
    {
        value: "large",
        label: "201-1000",
    },
    {
        value: "enterprise",
        label: "more 1000",
    },

]